<div
  class="draw-input pos-rel mt-2"
  [ngClass]="{ readonly: readonly }"
  (click)="openDrawPad()"
  >
  @if (value && !readonly) {
    <div
      class="delete-icon"
      (click)="clearDrawing(); $event.stopPropagation()"
      >
      <i class="fa-regular fa-xmark text-danger"></i>
    </div>
  }
  @if (value) {
    <div
      class="draw-image"
      [ngStyle]="{
        backgroundImage: 'url(' + ((value | localImage | async) || 'none') + ')'
      }"
    ></div>
  }
  <small class="text-xs color-light">{{
    '#UI_CORE.COMPONENTS.DRAW_INPUT.INFO' | translate
  }}</small>
</div>
